// Mirrors Tp_Communication.Constant.TpPlatformInvoiceConstants.Statuses — keep in sync.
const TpPlatformInvoiceStatusesEnum = {
  Pending: 'Pending',
  Summarized: 'Summarized',
  Ignored: 'Ignored',
};

export default TpPlatformInvoiceStatusesEnum;
